import type { Locale } from '@/i18n'

export const footerTranslations = {
  description: {
    uk: {
      line1: 'Роботизовані Системи',
      line2: '42 Механізованої Бригади',
    },
    en: {
      line1: 'Robotic Systems',
      line2: '42nd Mechanized Brigade',
    },
  },
  navigation: {
    uk: 'Навігація',
    en: 'Navigation',
  },
  contact: {
    uk: 'Контакти',
    en: 'Contact',
  },
  language: {
    uk: 'Мова',
    en: 'Language',
  },
  copyright: {
    uk: 'Всі права захищені.',
    en: 'All rights reserved.',
  },
  developer: {
    uk: 'Розробник:',
    en: 'Developer:',
  },
} as const

export const getFooterTranslations = (locale: Locale) => ({
  description: footerTranslations.description[locale],
  navigation: footerTranslations.navigation[locale],
  contact: footerTranslations.contact[locale],
  language: footerTranslations.language[locale],
  copyright: footerTranslations.copyright[locale],
  developer: footerTranslations.developer[locale],
})
